// Storage Items
export const RSVP_LOGIN_FLOW = "rsvp-login-flow";

// Custom Events
export const CLOSE_INFORMATION_MODAL = "CLOSE_INFORMATION_MODAL";
export const SHOW_LOGIN_MODAL = "SHOW_LOGIN_MODAL";
export const SHOW_RESULT_BANNER = "SHOW_RESULT_BANNER";
